import useActionHandler from './useActionHandler';

export default useActionHandler;

export * from './useSubmitOnActionHandler';
